App.factory('UsersClientService', UsersClientService);
App.factory('UserTypeService', UserTypeService);

function UsersClientService(Api) {
    var serviceObj =  new UsersClient.UserService(Api.url2 + '/v2');
    return serviceObj;
}

function UserTypeService() {
    return UsersClient.UserType;
}